import { render, staticRenderFns } from "./DashboardTasks.vue?vue&type=template&id=34e2ff9c"
import script from "./DashboardTasks.vue?vue&type=script&lang=js"
export * from "./DashboardTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports